module.exports = Em.Handlebars.compile("<iframe {{bind-attr src=videoSrc}} width=\"100%\" height=\"475\" frameBorder=\"0\" allowFullScreen></iframe>\n");